export default "__VITE_ASSET__D14MVPj1__"